export const align_left = () => (
  <path
    d="M17 10H3m18-4H3m18 8H3m14 4H3"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
